// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-affiliate-index-js": function componentSrcPagesAffiliateIndexJs() {
    return import("./../../src/pages/affiliate/index.js"
    /* webpackChunkName: "component---src-pages-affiliate-index-js" */
    );
  },
  "component---src-pages-affiliate-terms-index-js": function componentSrcPagesAffiliateTermsIndexJs() {
    return import("./../../src/pages/affiliate/terms/index.js"
    /* webpackChunkName: "component---src-pages-affiliate-terms-index-js" */
    );
  },
  "component---src-pages-every-funded-company-ever-index-js": function componentSrcPagesEveryFundedCompanyEverIndexJs() {
    return import("./../../src/pages/every-funded-company-ever/index.js"
    /* webpackChunkName: "component---src-pages-every-funded-company-ever-index-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-order-success-index-js": function componentSrcPagesOrderSuccessIndexJs() {
    return import("./../../src/pages/order-success/index.js"
    /* webpackChunkName: "component---src-pages-order-success-index-js" */
    );
  },
  "component---src-pages-press-index-js": function componentSrcPagesPressIndexJs() {
    return import("./../../src/pages/press/index.js"
    /* webpackChunkName: "component---src-pages-press-index-js" */
    );
  },
  "component---src-pages-privacy-policy-index-js": function componentSrcPagesPrivacyPolicyIndexJs() {
    return import("./../../src/pages/privacy-policy/index.js"
    /* webpackChunkName: "component---src-pages-privacy-policy-index-js" */
    );
  },
  "component---src-pages-subscription-success-index-js": function componentSrcPagesSubscriptionSuccessIndexJs() {
    return import("./../../src/pages/subscription-success/index.js"
    /* webpackChunkName: "component---src-pages-subscription-success-index-js" */
    );
  },
  "component---src-pages-terms-index-js": function componentSrcPagesTermsIndexJs() {
    return import("./../../src/pages/terms/index.js"
    /* webpackChunkName: "component---src-pages-terms-index-js" */
    );
  },
  "component---src-pages-the-great-american-startup-list-index-js": function componentSrcPagesTheGreatAmericanStartupListIndexJs() {
    return import("./../../src/pages/the-great-american-startup-list/index.js"
    /* webpackChunkName: "component---src-pages-the-great-american-startup-list-index-js" */
    );
  },
  "component---src-pages-vs-apollo-index-js": function componentSrcPagesVsApolloIndexJs() {
    return import("./../../src/pages/vs/apollo/index.js"
    /* webpackChunkName: "component---src-pages-vs-apollo-index-js" */
    );
  },
  "component---src-pages-vs-clearbit-index-js": function componentSrcPagesVsClearbitIndexJs() {
    return import("./../../src/pages/vs/clearbit/index.js"
    /* webpackChunkName: "component---src-pages-vs-clearbit-index-js" */
    );
  },
  "component---src-templates-tech-js": function componentSrcTemplatesTechJs() {
    return import("./../../src/templates/tech.js"
    /* webpackChunkName: "component---src-templates-tech-js" */
    );
  }
};